module.exports = __webpack_public_path__ + "assets/img/arrow_left.695fe488.png";